import React, { Fragment } from 'react';
import styled from 'styled-components';

import { Icon } from 'ensightful-koala-ui';
import { Body2 } from 'components/atoms/Text';
import { TextButton } from 'components/molecules/Button';

const PopoverContainer = styled.div`
    position: absolute;
    width: ${(props) => props.width};
    background-color: white;
    border-radius: 12px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1), 0px 2px 2px 0px rgba(0, 0, 0, 0.03);
    z-index: 99;
    transform: translate(-134px, 0px);
    cursor: default;
`;

const Triangle = styled.div`
    position: absolute;
    top: -5px;
    left: ${(props) => props.position};
    width: 11px;
    height: 11px;
    background-color: white;
    transform: rotate(45deg);
    border-radius: 1px;
`;

const AttentionIcon = styled(Icon)`
    width: 24px;
    height: 24px;
    margin: 0 8px 0 16px;
`;

const TextContainer = styled.div`
    width: 230px;
    align-content: right;
    margin: 10px 15px 10px 0;
`;

const Divider = styled.div`
    width: auto;
    height: 1px;
    background-color: #e0e0e0;
    margin: 5px 15px 5px 15px;
`;

const ContentContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const ViewAll = styled(TextButton)`
    float: right;
    margin-bottom: 12px;
`;

const AttentionPopover = ({ width = '293', height = '60', messages, onClickViewAll }) => {
    const position = (width / 2 - 5.5).toString().concat('px');
    return (
        <PopoverContainer width={width.concat('px')} height={height.concat('px')}>
            {messages.slice(0, 2).map((element, i) => (
                <Fragment key={i}>
                    <ContentContainer>
                        <AttentionIcon kind={'warning'}></AttentionIcon>
                        <TextContainer>
                            <Body2>{element}</Body2>
                        </TextContainer>
                    </ContentContainer>
                    {messages.length > 1 && i === 0 ? <Divider></Divider> : <></>}
                </Fragment>
            ))}
            {messages.length > 2 && <ViewAll onClick={onClickViewAll}>View all ({messages.length}) &gt;</ViewAll>}
            <Triangle position={position}></Triangle>
        </PopoverContainer>
    );
};
export default AttentionPopover;
